<div class="">
    <p-carousel class="p-col-12" [numVisible]="2" [numScroll]="1" [autoplayInterval]="5000" [value]="products" [circular]="true" [responsiveOptions]="responsiveOptions">
        <ng-template let-product pTemplate="item">
            <div class="product-item">
                <div class="product-item-content">
                    <div class="p-col-12">
                        <app-img [imagePath]="product.coverPath" [style]="'width: 100%;'"></app-img>
                    </div>
                    <div>
                        <h4 class="p-mb-1">{{ product.title | translate }}</h4>
                        <p-button class="p-col-2" label="{{ 'common.detail' | translate }}" icon="pi pi-check" [routerLink]="product.url"></p-button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-carousel>
    <div class="p-d-flex p-flex-column">
        <p-fieldset class="p-pt-2" legend="{{ 'presentation.activities.title' | translate }}" [toggleable]="true" [collapsed]="true">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <app-gallery [imagesInput]="images"></app-gallery>
                </div>
                <div class="p-col-12 p-md-6 p-text-justify">
                    <span [innerHTML]="'presentation.activities.description' | translate"></span>
                </div>
            </div>
        </p-fieldset>
        <p-fieldset class="p-pt-2" legend="{{ 'presentation.mission.title' | translate }}" [toggleable]="true" [collapsed]="true">
            <div class="p-col-12 p-text-justify">
                <span [innerHTML]="'presentation.mission.description' | translate"></span>
            </div>
        </p-fieldset>
        <p-fieldset class="p-pt-2" legend="{{ 'presentation.who.title' | translate }}" [toggleable]="true" [collapsed]="true">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <app-img [imagePath]="'assets/images/presentation/profil.JPG'" [style]="'width: 100%;'"></app-img>
                </div>
                <div class="p-col-12 p-md-6 p-text-justify">
                    <span [innerHTML]="'presentation.who.description' | translate"></span>
                </div>
            </div>
        </p-fieldset>
    </div>
</div>
